<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wKE95o/tc-custom/9781467432597.jpg?1731796518495" alt="This image is the cover for the book Ben and the Emancipation Proclamation, Incredible Lives for Young Readers (ILYR)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ben and the Emancipation Proclamation, Incredible Lives for Young Readers (ILYR)
      </h1>
      <p class="bookDescription body article font2">
        <p>Ben, a young slave, uses every chance he gets to teach himself to read, practicing with the words he sees on street signs and in shop windows and even in cast-off newspapers he finds in the gutter.<br/><br/>But after the Civil War breaks out, his master leaves town and Ben finds himself in a slave prison. One night, the prisoners bribe a guard to get their hands on a newspaper, and to the applause of his fellow slaves, Ben reads aloud the momentous news of Mr. Lincoln's Emancipation Proclamation — surely one of the most remarkable readings of that document ever.<br/><br/>Based on the true story of Benjamin Holmes, Pat Sherman's stirring text and the memorable illustrations of Coretta Scott King medalist Floyd Cooper pay tribute to the power of freedom — and to the power of the written word.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pat Sherman, Floyd Cooper
      </h2>
      
      <p class="authorDescription body article">Pat Sherman works as a writer, library professional, andwriting instructor in Cambridge, Massachusetts. Herprevious books include The Sun's Daughter,illustrated by R. Gregory Christie (Clarion), and severalnonfiction books for young people on historical subjectsranging from colonial America to the present day.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77b67aa0